export default {"src":"/planos/_next/static/media/equifax-user-analysis.55a9ce4a.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};